import React from 'react'
import './footer.css';

function index() {
  return (
    <footer className='footer' >
         <div >
        <p className="m-2">Copyright &copy; 2023 All rights reserved | AK Grocery Store</p>
      </div>
    </footer>
  )
}

export default index